import apiService from './api';
import { LoginCredentials, User } from '../types/authTypes';
import { getCurrentSubdomain } from '../utils/subdomainUtils';

export interface DataResponse {
  user: User;
  token: string;
  error: string;
}

export interface AuthResponse {
  status: boolean,
  data: DataResponse
}

class AuthService {
  // async login(credentials: LoginCredentials): Promise<AuthResponse> {
  //   // Mock authentication for development
  //   if (credentials.email === 'admin@example.com' && credentials.password === 'password123') {
  //     const mockUser: User = {
  //       id: '1',
  //       username: 'admin',
  //       email: 'admin@example.com',
  //       role: 'admin',
  //       isActive: true,
  //       permissions: {
  //         canManageCustomers: true,
  //         canManageInvoices: true,
  //         canManageEmployees: true,
  //         canViewReports: true,
  //         canManageSettings: true,
  //       },
  //       createdAt: new Date().toLocaleDateString('en-CA'),
  //       updatedAt: new Date().toLocaleDateString('en-CA'),
  //     };
      
  //     const mockToken = 'mock-jwt-token-admin';
      
  //     return {
  //       user: mockUser,
  //       token: mockToken,
  //     };
  //   } else if (credentials.email === 'employee@example.com' && credentials.password === 'password123') {
  //     const mockUser: User = {
  //       id: '2',
  //       username: 'employee',
  //       email: 'employee@example.com',
  //       role: 'employee',
  //       isActive: true,
  //       permissions: {
  //         canManageCustomers: false,
  //         canManageInvoices: true,
  //         canManageEmployees: false,
  //         canViewReports: false,
  //         canManageSettings: false,
  //       },
  //       createdAt: new Date().toLocaleDateString('en-CA'),
  //       updatedAt: new Date().toLocaleDateString('en-CA'),
  //     };
      
  //     const mockToken = 'mock-jwt-token-employee';
      
  //     return {
  //       user: mockUser,
  //       token: mockToken,
  //     };
  //   } else if (credentials.email === 'employee.customer@example.com' && credentials.password === 'password123') {
  //     const mockUser: User = {
  //       id: '3',
  //       username: 'employee_with_customers',
  //       email: 'employee.customer@example.com',
  //       role: 'employee',
  //       isActive: true,
  //       permissions: {
  //         canManageCustomers: true, // Admin granted this permission
  //         canManageInvoices: true,
  //         canManageEmployees: false,
  //         canViewReports: false,
  //         canManageSettings: false,
  //       },
  //       createdAt: new Date().toLocaleDateString('en-CA'),
  //       updatedAt: new Date().toLocaleDateString('en-CA'),
  //     };
      
  //     const mockToken = 'mock-jwt-token-employee-customer';
      
  //     return {
  //       user: mockUser,
  //       token: mockToken,
  //     };
  //   } else {
  //     throw new Error('Invalid email or password');
  //   }
  // }

  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    // Get current subdomain if available
    const subdomain = getCurrentSubdomain();
    
    // Add subdomain to login request if available
    const loginData = {
      ...credentials,
      ...(subdomain && { subdomain })
    };
    
    const response = await apiService.post<DataResponse>('/auth/login', loginData);
    const resData = response.data;

    console.log("resData:::::::", resData);
  
    if (!response.status) {
      throw new Error(resData.error || 'Login failed');
    }
  
    this.setToken(resData.token);
    this.setUser(resData.user);
    
    // Store company_id if available in user data
    if (resData.user.company_id) {
      this.setCompanyId(resData.user.company_id);
    }
    
    // Store subdomain if available
    if (subdomain) {
      this.setSubdomain(subdomain);
    }

    return {
      status: response.status,
      data: resData,
    };
  }
  

  async logout(): Promise<void> {
    try {
      await apiService.post('/auth/logout');
    } catch (error) {
      // Even if logout fails, clear local storage
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  }

  async getCurrentUser(): Promise<User> {
    // Mock current user for development
    // const token = this.getToken();
    // if (token === 'mock-jwt-token-admin') {
    //   return {
    //     id: '1',
    //     username: 'admin',
    //     email: 'admin@example.com',
    //     role: 'admin',
    //     is_active: true,
    //     permissions: {
    //       canManageCustomers: true,
    //       canManageInvoices: true,
    //       canManageEmployees: true,
    //       canViewReports: true,
    //       canManageSettings: true,
    //     },
    //     createdAt: new Date().toLocaleDateString('en-CA'),
    //     updatedAt: new Date().toLocaleDateString('en-CA'),
    //   };
    // } else if (token === 'mock-jwt-token-employee') {
    //   return {
    //     id: '2',
    //     username: 'employee',
    //     email: 'employee@example.com',
    //     role: 'employee',
    //     isActive: true,
    //     permissions: {
    //       canManageCustomers: false,
    //       canManageInvoices: true,
    //       canManageEmployees: false,
    //       canViewReports: false,
    //       canManageSettings: false,
    //     },
    //     createdAt: new Date().toLocaleDateString('en-CA'),
    //     updatedAt: new Date().toLocaleDateString('en-CA'),
    //   };
    // } else if (token === 'mock-jwt-token-employee-customer') {
    //   return {
    //     id: '3',
    //     username: 'employee_with_customers',
    //     email: 'employee.customer@example.com',
    //     role: 'employee',
    //     isActive: true,
    //     permissions: {
    //       canManageCustomers: true, // Admin granted this permission
    //       canManageInvoices: true,
    //       canManageEmployees: false,
    //       canViewReports: false,
    //       canManageSettings: false,
    //     },
    //     createdAt: new Date().toLocaleDateString('en-CA'),
    //     updatedAt: new Date().toLocaleDateString('en-CA'),
    //   };
    // }
    throw new Error('User not found');
  }

  async refreshToken(): Promise<{ token: string }> {
    const response = await apiService.post<{ token: string }>('/auth/refresh');
    return response.data;
  }

  async setup2FA() {
    const response = await apiService.post('/tfa/2fa/setup');
    return response.data;
  }

  async verify2FA(code: string) {
    const response = await apiService.post('/tfa/2fa/verify', { code });
    return response.data;
  }

  async verify2FAPin(code: string) {
    const response = await apiService.post('/tfa/2fa/verify-pin', { code });
    return response.data;
  }

  async disable2FA() {
    const response = await apiService.post('/tfa/2fa/disable');
    return response.data;
  }

  async get2FAStatus() {
    const response = await apiService.get('/tfa/2fa/status');
    console.log("response54332::::::", response.data)
    return response.data;
  }

  async resetPassword(currentPassword: string, newPassword: string) {
    const response = await apiService.post('/auth/reset-password', {
      current_password: currentPassword,
      new_password: newPassword
    });
    return response.data;
  }

  // Local storage helpers
  setToken(token: string): void {
    localStorage.setItem('token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  setUser(user: User): void {
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUser(): User | null {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }

  setCompanyId(companyId: number): void {
    localStorage.setItem('company_id', companyId.toString());
  }

  getCompanyId(): number | null {
    const companyId = localStorage.getItem('company_id');
    return companyId ? parseInt(companyId) : null;
  }

  setSubdomain(subdomain: string): void {
    localStorage.setItem('subdomain', subdomain);
  }

  getSubdomain(): string | null {
    return localStorage.getItem('subdomain');
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  clearAuth(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('company_id');
    localStorage.removeItem('subdomain');
  }
}

export const authService = new AuthService();
export default authService; 